import "../css/about.scss";
import {Button} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PropTypes from "prop-types";

function TwoColumnAllText({
    smallTitle,
    title,
    col1Text,
    col2Text,
    link,
    buttonText,
    classes, // main, pink, yellow,
}) {
    return (
        <>
            {/* Mobile*/}
            <Container fluid className={`${classes} d-block d-md-none`}>
                {smallTitle ? <h5>{smallTitle}</h5> : <></>}
                <h1>{title}</h1>
                <Row>
                    <Col sm="6">{col1Text}</Col>
                    <Col sm="6">{col2Text}</Col>
                </Row>
            </Container>

            {/* Desktop*/}
            <Container fluid className={`${classes} d-none d-md-block`}>
                <Row>
                    <Col sm="2"/>
                    <Col sm="8" >
                        {smallTitle ? <h5>{smallTitle}</h5> : <></>}
                        <h1>{title}</h1>
                        <Row style={{textAlign: "left"}}>
                            <Col sm="6" style={{borderRight: "2px solid gray", paddingRight: "60px"}}>{col1Text}</Col>
                            <Col sm="6" style={{paddingLeft: "60px"}}>{col2Text}</Col>
                        </Row>
                        {
                            link
                                ? <p className="pt-4">
                                    <Button variant="danger" href={link}>
                                        {buttonText}
                                    </Button>
                                </p>
                                : <></>
                        }
                    </Col>
                    <Col sm="2"/>
                </Row>
            </Container>
        </>
    );
}

TwoColumnAllText.propTypes = {
    smallTitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    link: PropTypes.string,
    col1Text: PropTypes.array.isRequired,
    col2Text: PropTypes.array.isRequired,
    buttonText: PropTypes.string,
    classes: PropTypes.string.isRequired,
};

export default TwoColumnAllText;
